import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: `/admin/admin/member${query.memberType === 'ENTERPRISE' ? '/official' : ''}/page`,
    method: 'get',
    params: query
  })
}

export function getMemberTotal () {
  return request({
    url: '/admin/admin/member/total',
    method: 'get',
  })
}

export function fetchMemberCircleList(query, memberId){
  return request({
    url: `/admin/post/member/${memberId}/circles/page`,
    method: 'get',
    params: query
  })
}

export function fetchMemberFollowList(query, memberId) {
  return request({
    url: '/admin/admin/member/follow/' + memberId,
    method: 'get',
    params: query
  })
}

export function fetchMemberFansList(query, memberId) {
  return request({
    url: '/admin/admin/member/fans/' + memberId,
    method: 'get',
    params: query
  })
}

export function fetchMemberInviteeList(query, memberId) {
  return request({
    url: `/admin/admin/member/invitee/${memberId}`,
    method: 'get',
    params: query
  })
}

export function getObj (id) {
    return request({
      url: '/admin/admin/member/' + id,
      method: 'get'
    })
}

export function delObj (id) {
    return request({
      url: '/admin/admin/member/' + id,
      method: 'delete'
    })
}

export function putObj (id, obj) {
    return request({
      url: '/admin/admin/member/' + id,
      method: 'put',
      data: obj
    })
}

export function addOfficialMember (obj) {
  return request({
    url: '/admin/admin/member/official/add',
    method: 'post',
    data: obj
  })
}

export function updateOfficialMember (id, obj) {
  return request({
    url: '/admin/admin/member/official/' + id,
    method: 'put',
    data: obj
  })
}

export function fetchAllByType (type) {
  return request({
    url: '/admin/admin/member/all/' + type,
    method: 'get'
  })
}

export function getTag(id) {
    return request({
      url:'/admin/admin/member/tag/' + id,
      method: 'get'
    })
}

export function putTag (obj) {
    return request({
      url:'/admin/admin/member/tag',
      method: 'put',
      data: obj
    })
}

export function getAllMembersAdmin () {
  return request({
    url: '/admin/admin/member/all',
    method: 'get'
  })
}

export function getProvinces() {
  return request({
    url: '/basic/location/list',
    method: 'get'
  })
}

export function getCitiesByProvinceId(id) {
  return request({
    url: '/basic/location/province/' + id + '/cities',
    method: 'get'
  })
}

export function getMembersByName(param) {
  return request({
    url: '/admin/admin/member/by-name',
    method: 'get',
    params: param,
  })
}

export function getMembersByNickname(param) {
  return request({
    url: '/admin/admin/member/by-nickname',
    method: 'get',
    params: param,
  })
}

export function getSubLobsByDepartment(param) {
  return request({
    url: '/admin/admin/member/departments',
    method: 'get',
    params: param,
  })
}

export function exports(param) {
  return request({
    url: '/admin/export/member',
    method: 'get',
    params: param,
  })
}

export function getExportFileAddress(uuid) {
  return request({
    url: 'admin/export/address/' + uuid,
    method: 'get',
  })
}

export function updateMember(data) {
  return request({
    url: `/admin/admin/member/${data.id}`,
    method: 'put',
    data,
  })
}

export function updateMemberStatus (obj) {
  return request({
    url:'/admin/admin/member/update/status',
    method: 'put',
    data: obj
  })
}

export function fetchMarketOptions() {
  return request({
    url: '/admin/admin/market-city/list',
    method: 'get'
  })
}

export function fetchOrganizationTagList(query) {
  return request({
    url: '/admin/admin/member/organization-tag/page',
    method: 'get',
    params: query
  })
}

export function importOrganizationTagList(data) {
  return request({
    url: '/admin/admin/member/organization-tag/import',
    method: 'post',
    data,
  })
}

export function fetchOrganizationTagImportTemplate() {
  return request({
    url: '/admin/admin/member/organization-tag/import-template',
    method: 'get',
  })
}

export function deleteMemberTag(id) {
  return request({
    url: `/admin/admin/member/organization-tag/${id}`,
    method: 'delete',
  })
}

export function addMemberTag(tagId, unionIds) {
  return request({
    url: `/admin/admin/member/organization-tag/import`,
    method: 'post',
    params: { tagId, unionIds },
  })
}

export function fetchMemberTagList(tagId, params) {
  return request({
    url: `/admin/admin/organization-tag/${tagId}/member/page`,
    method: 'get',
    params,
  })
}

export function getMonthVisitCount(params) {
  return request({
    url: `/admin/admin/member/month/statistic/uv/latest-two-month?months=${params.months[0]},${params.months[1]}`,
    method: 'get',
  })
}

export function syncMemberById(id) {
  return request({
    url: `/admin/thirdparty/member/${id}`,
    method: 'put',
  })
}

export function addRelatedUnionId (obj) {
  return request({
    url: '/admin/admin/member/official/related',
    method: 'post',
    data: obj
  })
}

export function updateRelatedStatus(params) {
  return request({
    url: '/admin/admin/member/official/related',
    method: 'put',
    params: params
  })
}

export function updateMemberTierByMemberId(memberId, tierId) {
  return request({
    url:`/admin/admin/member/tier/${memberId}/${tierId}`,
    method: 'put'
  })
}

export function fetchMemberImportTemplate() {
  return request({
    url: '/admin/admin/member/import-template',
    method: 'get',
  })
}

export function importMembers(data) {
  return request({
    url: '/admin/admin/member/import',
    method: 'post',
    data,
    timeout: 60000
  })
}

export function fetchMemberPhoneNumber(unionId) {
  return request({
    url: `/admin/admin/member/phone-number/${unionId}`,
    method: 'get',
  })
}

export function getImportMemberFileData(data) {
  return request({
    url: '/admin/admin/member/import/file-data',
    method: 'post',
    data,
  })
}